<template>
  <div class="hm-card" :class="($template === 'article') ? 'article' : 'small'">
    <div class="max-w">
      <div v-if="$store.getters['getScore']() > 0 || $store.getters['getData']().hasMedicaid">
        <h2>Fantastic! {{ $store.getters['getScore']() }}% Coverage</h2>
        <img :class="{ 'article': ($template === 'article') }" src="//hm-lis.herokuapp.com/img/svg/Good-News.svg" alt="image" class="score-banner good-news">
        <p>
          You probably qualify for a subsidy that covers {{$store.getters['getScore']()}}% of your prescription drug coverage premium cost.
        </p>
        <p>
          We’ll make sure our plan recommendations reflect the cost savings you’re likely to receive.
        </p>
      </div>
      <div v-else>
        <h2 v-if="($template === 'small')">You Probably Don’t Qualify for Discounts on Prescription Drug Coverage</h2>
        <img v-if="($template === 'small')" :class="{ 'article': ($template === 'article') }" src="//hm-lis.herokuapp.com/img/svg/LIS-Drug-Savings.svg" alt="image" class="score-banner">
        <p>
          Based on the information you provided, you probably don’t qualify for discounts on Prescription Drug Coverage.
        </p>
        <p>
          It’s OK – there are still plenty of plans that may help you save money.
        </p>
      </div>

      <br>
      <SuiButton color="green" :class="{ 'article': ($template === 'article') }" @click="onClickLink">{{ linkLabel }}</SuiButton>

    </div>
  </div>
</template>

<script>
  import {Button} from 'semantic-ui-vue/dist/commonjs/elements/Button';

  export default {
    name: 'Final',
    components: {
      SuiButton: Button,
    },
    data() {
      return {
        result: 0,
        linkLabel: this.$finalLinkLabel || 'Free Quote',
        linkUrl: 'https://shop.model.healthmarkets.com/about-me/plans-found',
      }
    },
    created() {
      const params = this.$store.getters['getQueryParams']();
      this.$data.linkUrl = `https://shop.healthmarkets.com/?${this.encodeQueryData(params)}`;
    },
    async beforeMount() {
      try {
        await this.$store.dispatch('calculate');
      } catch (error) {
        // console.error(error);
      }
    },
    methods: {
      onClickLink() {
        window.open(this.$data.linkUrl, '_blank');
      },
      encodeQueryData(data) {
        const ret = [
          'medicareYear=2020',
          'product=medicare',
        ];
        for (let d in data)
          ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
        return ret.join('&');
      },
    },
  }
</script>
